import { render, staticRenderFns } from "./AbStart.vue?vue&type=template&id=c52c2fba"
import script from "./AbStart.vue?vue&type=script&lang=ts"
export * from "./AbStart.vue?vue&type=script&lang=ts"
import style0 from "./AbStart.vue?vue&type=style&index=0&id=c52c2fba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports